namespace TabAurous.Retail {
    export namespace ProductWiseSalesService {
        export const baseUrl = 'POSSales/ProductWiseSales';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "POSSales/ProductWiseSales/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ProductWiseSalesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
